const BASE_PERMISSION_MAP = {
  index: 'view',
  store: 'add',
  update: 'edit',
  show: 'show',
  destroy: 'delete',
  restore: 'restore'
}

export const state = () => ({
  token: '',
  user: null,
  roles: [],
  permissionsLoaded: false
})

export const getters = {
  isLoggedIn: state => !!state.token,

  allPermissions (state) {
    const permsSet = new Set()
    state.roles.forEach((role) => {
      role.permissions.forEach(perm => permsSet.add(perm.name))
    })
    return Array.from(permsSet)
  },

  // hasPermission('indexRole') or hasPermission(['indexRole', 'storeRole'])
  hasPermission: (state, getters) => (permission) => {
    if (!permission) {
      return true
    }
    if (Array.isArray(permission)) {
      return permission.some(p => getters.allPermissions.includes(p))
    }
    return getters.allPermissions.includes(permission)
  },

  // hasAtLeaseOnePermission(['indexRole', 'storeRole'])
  hasAtLeaseOnePermission: (state, getters) => (permissions) => {
    return permissions.some(p => getters.allPermissions.includes(p))
  },

  // getModulePermissions('Role') → { view: true, add: false, edit: true, ... }
  getModulePermissions: state => (group) => {
    const groupPerms = state.roles.flatMap(role =>
      role.permissions.filter(p => p.group === group).map(p => p.name)
    )
    const result = {}
    Object.entries(BASE_PERMISSION_MAP).forEach(([apiAction, uiKey]) => {
      result[uiKey] = groupPerms.includes(`${apiAction}${group}`)
    })
    return result
  }
}

export const mutations = {
  SET_TOKEN (state, token) {
    state.token = token || ''
  },
  SET_USER (state, user) {
    state.user = user
  },
  SET_ROLES (state, roles) {
    state.roles = roles
  },
  SET_PERMISSIONS_LOADED (state, value) {
    state.permissionsLoaded = value
  },
  RESET (state) {
    state.token = ''
    state.user = null
    state.roles = []
    state.permissionsLoaded = false
  }
}

export const actions = {
  async loadProfile ({ commit }) {
    const response = await this.$axios.$get('/profile')
    const data = response.data.user
    console.log('Loaded user profile:', data)

    commit('SET_USER', {
      id: data.id || '',
      firstName: data.first_name || '',
      lastName: data.last_name || '',
      email: data.email || '',
      emailVerified: !!data.email_verified,
      email_verified: data.email_verified || '', // in case the email_verified used in any component
      birth: data.birth || '',
      phone: data.phone || '',
      gender: data.gender || '',
      avatar: data.avatar || ''
    })

    const roles = (data.roles || []).map(role => ({
      id: role.id,
      name: role.name,
      permissions: (role.permissions || []).map(p => ({
        id: p.id,
        name: p.name,
        displayName: p.display_name || '',
        group: p.group || null
      }))
    }))

    commit('SET_ROLES', roles)
  },

  setToken ({ commit }, token) {
    commit('SET_TOKEN', token)
    if (token) {
      localStorage.setItem('auth_token', token)
    } else {
      localStorage.removeItem('auth_token')
    }
  },

  reset ({ commit }) {
    commit('RESET')
    localStorage.removeItem('auth_token')
    localStorage.removeItem('subtoken')
  }
}
